import { Component, OnInit } from '@angular/core';
import { EditForm } from '../../../../base/controlers/edit-form';
import { LayoutType } from '../../models/layout-type';
import { LayoutTypeService } from '../../services/layout-type.service';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { IFileStoreItem } from '../../../../documents/interfaces/IFileStoreItem';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceAutoComplete } from '../../../../documents/document-reference/reference-auto-complete';
import { ItemService } from '../../services/item-service.service';

@Component({
  selector: 'app-layout-type-edit',
  templateUrl: './layout-type-edit.component.html',
  styleUrls: ['./layout-type-edit.component.css']
})
export class LayoutTypeEditComponent extends EditForm<LayoutType> implements OnInit {

  constructor(
    ns: ToastrService,          
    tr: TranslateService,
    r: Router,
    ds:LayoutTypeService,
    ar: ActivatedRoute,
    l:Location,
    private ItemService:ItemService 
  ) {
    super(ns,tr,r,ds,ar,l,'/plasard-measurement/layout-type', [
      {
        id: '15a773fd-43d1-4458-822c-3775b743409a',
        code:'active',
        name: 'Aktiven'
      }
    ]);
  }

  ngOnInit() {
    this.form = new FormGroup({
      id: new FormControl(),
      stateId: new FormControl(),
      code: new FormControl(),
      name: new FormControl(),
      picture: new FormControl(),
      itemId: new FormControl(null, Validators.required),        
      itemName: new FormControl(null),
      itemQuantity: new FormControl(1),
      itemPrice: new FormControl(0),
      itemPriceInternal: new FormControl(0),
      itemAmount: new FormControl(0),
      itemAmountInternal: new FormControl(0),
      parentTypeId: new FormControl(null),
      outsideLeft: new FormControl(false),
      outsideRight: new FormControl(false),
      outsideCenter: new FormControl(false),
      insideLeft: new FormControl(false),
      insideRight: new FormControl(false),
      insideCenter: new FormControl(false),      
    });
    super.ngOnInit();
  }

  onFileUpload(file:IFileStoreItem){
    if(file){
      this.form.controls['picture'].setValue(file.id);
    }
    else {
      this.form.controls['picture'].setValue(null);
    }
  }
  onItemSelected(item:ReferenceAutoComplete){
    //Item
    if(item && item.id){
      this.ItemService.Get(item.id).subscribe(response => {
        const quantity:number = this.form.get('itemQuantity').value;
        if(response && response.payload){
          if(!quantity){
            this.form.get('itemQuantity').setValue(1);
            this.form.get('itemPrice').setValue(response.payload.price);
            this.form.get('itemPriceInternal').setValue(response.payload.priceInternal);            
            this.form.get('itemAmount').setValue(response.payload.price);
            this.form.get('itemAmountInternal').setValue(response.payload.priceInternal);                        
          }          
        }
      })
    }
  }
}
